// Wizard
export const SET_WIZARD_STEP = 'SET_WIZARD_STEP';
export const COMPLETE_WIZARD = 'COMPLETE_WIZARD';
export const RESET_ALL = 'RESET_ALL';

// Income
export const ADD_INCOME = 'ADD_INCOME';
export const UPDATE_INCOME = 'UPDATE_INCOME';
export const REMOVE_INCOME = 'REMOVE_INCOME';

// Fixed Expenses
export const ADD_FIXED_EXPENSE = 'ADD_FIXED_EXPENSE';
export const UPDATE_FIXED_EXPENSE = 'UPDATE_FIXED_EXPENSE';
export const REMOVE_FIXED_EXPENSE = 'REMOVE_FIXED_EXPENSE';

// Variable Expenses
export const ADD_VARIABLE_EXPENSE = 'ADD_VARIABLE_EXPENSE';
export const UPDATE_VARIABLE_EXPENSE = 'UPDATE_VARIABLE_EXPENSE';
export const REMOVE_VARIABLE_EXPENSE = 'REMOVE_VARIABLE_EXPENSE';

// Goals
export const SET_GOALS = 'SET_GOALS';

// Debts
export const ADD_DEBT = 'ADD_DEBT';
export const UPDATE_DEBT = 'UPDATE_DEBT';
export const REMOVE_DEBT = 'REMOVE_DEBT';
export const SET_DEBT_STRATEGY = 'SET_DEBT_STRATEGY';

// Batch operations (for presets)
export const BATCH_SET_FIXED_EXPENSES = 'BATCH_SET_FIXED_EXPENSES';
export const BATCH_SET_VARIABLE_EXPENSES = 'BATCH_SET_VARIABLE_EXPENSES';

// Hydrate from localStorage
export const HYDRATE = 'HYDRATE';

// Action creators
let nextId = Date.now();
const uid = () => String(nextId++);

export const setWizardStep = (step) => ({ type: SET_WIZARD_STEP, payload: step });
export const completeWizard = () => ({ type: COMPLETE_WIZARD });
export const resetAll = () => ({ type: RESET_ALL });

export const addIncome = (source) => ({
  type: ADD_INCOME,
  payload: { ...source, id: uid() },
});
export const updateIncome = (source) => ({ type: UPDATE_INCOME, payload: source });
export const removeIncome = (id) => ({ type: REMOVE_INCOME, payload: id });

export const addFixedExpense = (expense) => ({
  type: ADD_FIXED_EXPENSE,
  payload: { ...expense, id: uid() },
});
export const updateFixedExpense = (expense) => ({ type: UPDATE_FIXED_EXPENSE, payload: expense });
export const removeFixedExpense = (id) => ({ type: REMOVE_FIXED_EXPENSE, payload: id });

export const addVariableExpense = (expense) => ({
  type: ADD_VARIABLE_EXPENSE,
  payload: { ...expense, id: uid() },
});
export const updateVariableExpense = (expense) => ({ type: UPDATE_VARIABLE_EXPENSE, payload: expense });
export const removeVariableExpense = (id) => ({ type: REMOVE_VARIABLE_EXPENSE, payload: id });

export const setGoals = (goals) => ({ type: SET_GOALS, payload: goals });

export const addDebt = (debt) => ({
  type: ADD_DEBT,
  payload: { ...debt, id: uid() },
});
export const updateDebt = (debt) => ({ type: UPDATE_DEBT, payload: debt });
export const removeDebt = (id) => ({ type: REMOVE_DEBT, payload: id });
export const setDebtStrategy = (strategy) => ({ type: SET_DEBT_STRATEGY, payload: strategy });

export const batchSetFixedExpenses = (expenses) => ({
  type: BATCH_SET_FIXED_EXPENSES,
  payload: expenses.map((e) => ({ ...e, id: e.id || uid() })),
});

export const batchSetVariableExpenses = (expenses) => ({
  type: BATCH_SET_VARIABLE_EXPENSES,
  payload: expenses.map((e) => ({ ...e, id: e.id || uid() })),
});

export const hydrate = (state) => ({ type: HYDRATE, payload: state });
